import { Component } from '@angular/core';

@Component({
  selector: 'app-omkar-industries',
  templateUrl: './omkar-industries.component.html',
  styleUrls: ['./omkar-industries.component.scss']
})
export class OmkarIndustriesComponent {

}
